module.exports = __webpack_public_path__ + "static/media/personal-details.d0089cfb.svg";